import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";


const ServiceTermsVersion1: React.FC = () => {
  const [content, setContent] = useState("");

  useEffect(() => {
    fetch("/ServiceTermsText.md")
      .then((response) => response.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <div className="min-h-screen overflow-y-auto">
      <div className="w-full py-4 px-3 md:px-4 lg:px-5">
        <div className="service-terms-content">
          <ReactMarkdown>{content}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default ServiceTermsVersion1;
